module.exports = __webpack_public_path__ + "img/totop2.b299b504.png";